import { Route, Switch } from 'react-router-dom'
import * as views from '@/views'

const IframeRouter = () => (
    <Switch>
        <Route path="/iframe/plusminus-drawing-configurator" component={views.PlusminusDrawingConfiguratorIframeContent} exact />
        <Route path="/iframe/plusminus-export3d" component={views.Export3dIframeContent} />
        {/* DV-6607: the player alone, for a host that draws its own interface. */}
        <Route path="/iframe/export3d-player" component={views.Export3dPlayerIframeContent} />
        <Route component={views.NotFoundView} />
    </Switch>	
)

export default IframeRouter